import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import Novaicon from "../../assets/novaicon.png";
import Tutorialicon from "../../assets/play-button.png";
import SuggestionIcon from "../../assets/bug.png";
import WebIcon from "../../assets/external-link.png";
import { RiCloseLargeFill } from "react-icons/ri";

const S = {
  
  dialog: {
    maxWidth: 420,
  },
  body: {
    padding: 0,
    border: "none",
    borderRadius: "1rem",
    overflow: "hidden",
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    boxShadow: "0 12px 48px rgba(43,52,56,0.12)",
  },

  canvas: {
    position: "fixed",
    inset: 0,
    zIndex: -1,
    pointerEvents: "none",
    background:
      "linear-gradient(135deg,#f1f4f7 0%,#dae2ff 50%,#e3dbfd 100%)",
    filter: "blur(3px)",
    transform: "scale(1.02)",
  },


  inner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "2rem 1.5rem",
    position: "relative",
    backgroundColor:"#ffffffd9"
  },

  closeBtn: {
    position: "absolute",
    top: 20,
    right: 20,
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s",
    color: "#586065",
  },


  avatar: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: 24,
  },


  h2: {
    fontFamily: "Manrope, sans-serif",
    fontWeight: 700,
    fontSize: "1.5rem",
    letterSpacing: "-0.02em",
    color: "#2b3438",
    marginBottom: 18,
  },

  sub: {
    fontFamily: "Inter, sans-serif",
    fontSize: "0.9rem",
    color: "#586065",
    marginBottom: 36,
    maxWidth: 240,
    lineHeight: 1.5,
  },

  nav: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    marginTop:"20px"
  },


  tile: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.8rem 1rem",
    background: "#fff",
    borderRadius: "0.75rem",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 16px rgba(43,52,56,0.07)",
    transition: "transform 0.15s, box-shadow 0.15s",
    textDecoration: "none",
  },

  tileLeft: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },

  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: "0.5rem",
    background: "#29B6F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  iconImg: {
    width: 20,
    height: 20,
    objectFit: "contain",
    filter: "brightness(0) invert(1)",
  },

  tileLabel: {
    fontFamily: "Manrope, sans-serif",
    fontWeight: 700,
    fontSize: "0.95rem",
    color: "#2b3438",
  },

  chevron: {
    color: "#aab3b9",
    fontSize: 20,
    transition: "transform 0.15s",
  },

  /* footer */
  footer: {
    marginTop: 36,
    paddingTop: 28,
    borderTop: "1px solid rgba(170,179,185,0.2)",
    width: "100%",
  },
  footerText: {
    fontSize: "0.82rem",
    fontFamily: "Inter, sans-serif",
    color: "#586065",
  },
  footerLink: {
    color: "#0c56d0",
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "none",
  },
};


const useTileHover = () => {
  const [hovered, setHovered] = React.useState(false);
  return {
    hovered,
    handlers: {
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
    },
  };
};


const Tile = ({ icon, label, onClick, href }) => {
  const { hovered, handlers } = useTileHover();
  const tileStyle = {
    ...S.tile,
    transform: hovered ? "translateY(-2px)" : "none",
    boxShadow: hovered
      ? "0 8px 24px rgba(43,52,56,0.13)"
      : "0 4px 16px rgba(43,52,56,0.07)",
  };

  const content = (
    <>
      <div style={S.tileLeft}>
        <div style={S.iconWrap}>
          <img src={icon} alt={label} style={S.iconImg} />
        </div>
        <span style={S.tileLabel}>{label}</span>
      </div>
   
      
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={tileStyle}
        {...handlers}
        onClick={onClick}
      >
        {content}
      </a>
    );
  }

  return (
    <button style={tileStyle} {...handlers} onClick={onClick}>
      {content}
    </button>
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
const HelpModal = ({ isOpen, onClose, opensuggesstion }) => {
  const navigate = useNavigate();

  return (
    <Modal
      centered
      show={isOpen}
      onHide={onClose}
      backdrop={true}
      animation={true}
      id="help-modal-dialoghelp"
      contentClassName="help-modal-content"
      style={{ border: "none", backdropFilter: "blur(4px)" }}
    >
     
      <style>{`
        .help-modal-dialog { max-width: 320px !important; }
        .help-modal-content {
          border: none !important;
          border-radius: 0.5rem !important;
          background: rgba(255,255,255,0.88) !important;
          backdrop-filter: blur(20px) !important;
          -webkit-backdrop-filter: blur(20px) !important;
          box-shadow: 0 12px 48px rgba(43,52,56,0.14) !important;
          overflow: hidden !important;
        }
        .modal-backdrop { backdrop-filter: blur(4px); }
      `}</style>

      <Modal.Body style={{ padding: 0, border: "none" }}>
        <div style={S.inner}>
          {/* Close */}
          <button
            style={S.closeBtn}
            onClick={onClose}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "#f1f4f7")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
            aria-label="Close"
          >
            <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
              <RiCloseLargeFill />
            </span>
          </button>

         
          <img src={Novaicon} alt="Nova" style={S.avatar} />

       
          <h2 style={S.h2}>How may I help you?</h2>
          <p style={S.sub}>Our concierge is here to guide your editorial workflow.</p>

       
          <nav style={S.nav} >
            <Tile
              icon={Tutorialicon}
              label="View Tutorials"
              onClick={() => {
                onClose();
                navigate("/tutorials");
              }}
            />
            <Tile
              icon={SuggestionIcon}
              label="Report Bug / Suggestion"
              onClick={() => {
                onClose();
                opensuggesstion();
              }}
            />
            <Tile
              icon={WebIcon}
              label="Visit Website"
              href="https://www.trackhrapp.com/"
              onClick={onClose}
            />
          </nav>

          <div style={S.footer}>
            <p style={S.footerText}>
              Need immediate assistance?{" "}
              <span onClick={()=>{
                onClose()
                navigate("/novachatbot")
              }} style={S.footerLink}>
                Chat with Nova
              </span>
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HelpModal;
